/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件工具自动生成，请勿直接修改！！！ */

// @ts-ignore

import request from '@/utils/request/index';
/**
 * 接口 [智能体列表↗](https://yapi.fenxianglife.com/project/379/interface/api/42010) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/list`
 * @更新时间 `2024-04-19 10:58:51`
 */
export const feimaChatBotList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotListRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatBotListResponse, OT>>(
    '/bot/list',
    'POST',
    data,
    options
  );

/**
 * 接口 [智能体对话列表] 的 **请求函数**
 *
 * @分类 [智能体相关]
 * @请求头 `POST /bot/chat/list`
 */
export const feimaChatBotChatList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotListRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatBotListResponse, OT>>(
    '/bot/chat/list',
    'POST',
    data,
    options
  );

/**
 * 接口 [智能体面具列表↗](https://yapi.fenxianglife.com/project/379/interface/api/42016) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/mask/list`
 * @更新时间 `2023-08-04 11:40:00`
 */
export const feimaChatBotMaskList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotMaskListRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatBotMaskListResponse, OT>>(
    '/bot/mask/list',
    'POST',
    data,
    options
  );

/**
 * 接口 [编辑智能体↗](https://yapi.fenxianglife.com/project/379/interface/api/42208) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/edit`
 * @更新时间 `2023-12-12 15:37:32`
 */
export const feimaChatBotEdit = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotEditRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatBotEditResponse, OT>>(
    '/bot/edit',
    'POST',
    data,
    options
  );

/**
 * 接口 [上传智能体关联资源↗](https://yapi.fenxianglife.com/project/379/interface/api/42232) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/resource/upload`
 * @更新时间 `2023-08-30 16:32:19`
 */
export const feimaChatBotResourceUpload = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotResourceUploadRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatBotResourceUploadResponse, OT>
  >('/knowledge/upload', 'POST', data, { timeout: 0, ...options } as OT);

export const feimaChatBotKnowledgeBind = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotKnowledgeBindRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatBotKnowledgeBindResponse, OT>>(
    '/bot/knowledge/bind',
    'POST',
    data,
    options
  );

/**
 * 接口 [智能体关联资源列表↗](https://yapi.fenxianglife.com/project/379/interface/api/42238) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/resource/list`
 * @更新时间 `2023-08-31 17:06:53`
 */
export const feimaChatBotKnowledgeBotList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotResourceListRequest>,
  options?: OT
) => {
  return request<
    ToolTypes.GetResponseType<API.FeimaChatBotResourceListResponse, OT>
  >('/knowledge/bot/list', 'POST', data, options);
};

/**
 * 接口 [系统默认智能体知识库列表] 的 **请求函数**
 *
 * @请求头 `POST /bot/default/list`
 * 响应结构与 /knowledge/bot/list 兼容（data.list / data.endPage / data.totalCount），
 * 供超管「系统智能体配置 - 训练AI」复用 Knowledge 组件时使用。
 */
export const feimaChatBotDefaultList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotResourceListRequest>,
  options?: OT
) => {
  return request<
    ToolTypes.GetResponseType<API.FeimaChatBotResourceListResponse, OT>
  >('/knowledge/bot/default/list', 'POST', data, options);
};

/**
 * 接口 [删除智能体关联资源↗](https://yapi.fenxianglife.com/project/379/interface/api/42244) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /knowledge/delete`
 * @更新时间 `2023-08-31 09:48:52`
 */
export const feimaChatBotKnowledgeDelete = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotResourceDeleteRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatBotResourceDeleteResponse, OT>
  >('/knowledge/delete', 'POST', data, options);

/**
 * 接口 [编辑预设问题↗](https://yapi.fenxianglife.com/project/379/interface/api/42250) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/question/edit`
 * @更新时间 `2023-08-23 15:59:51`
 */
export const feimaChatBotQuestionEdit = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotQuestionEditRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatBotQuestionEditResponse, OT>>(
    '/bot/question/edit',
    'POST',
    data,
    options
  );

/**
 * 接口 [删除预设问题↗](https://yapi.fenxianglife.com/project/379/interface/api/42256) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/question/delete`
 * @更新时间 `2023-07-21 16:54:46`
 */
export const feimaChatBotQuestionDelete = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotQuestionDeleteRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatBotQuestionDeleteResponse, OT>
  >('/bot/question/delete', 'POST', data, options);

/**
 * 接口 [预设问题列表↗](https://yapi.fenxianglife.com/project/379/interface/api/42262) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/question/list`
 * @更新时间 `2023-08-04 11:34:38`
 */
export const feimaChatBotQuestionList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotQuestionListRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatBotQuestionListResponse, OT>>(
    '/bot/question/list',
    'POST',
    data,
    options
  );

/**
 * 接口 [查询智能体信息↗](https://yapi.fenxianglife.com/project/379/interface/api/42382) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/info`
 * @更新时间 `2023-12-06 09:52:17`
 */
export const feimaChatBotInfo = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotInfoRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatBotInfoResponse, OT>>(
    '/bot/info',
    'POST',
    data,
    options
  );

/**
 * 接口 [替换智能体关联资源↗](https://yapi.fenxianglife.com/project/379/interface/api/42514) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/resource/replace`
 * @更新时间 `2023-08-02 15:40:06`
 */
export const feimaChatBotResourceReplace = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotResourceReplaceRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatBotResourceReplaceResponse, OT>
  >('/bot/resource/replace', 'POST', data, options);

/**
 * 接口 [创建问答↗](https://yapi.fenxianglife.com/project/379/interface/api/42616) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/create/qa`
 * @更新时间 `2023-08-08 09:59:45`
 */
export const feimaChatBotCreateQa = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotCreateQaRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatBotCreateQaResponse, OT>>(
    '/bot/create/qa',
    'POST',
    data,
    options
  );

/**
 * 接口 [更新问答↗](https://yapi.fenxianglife.com/project/379/interface/api/42622) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/update/qa`
 * @更新时间 `2023-08-08 09:59:46`
 */
export const feimaChatBotUpdateQa = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotUpdateQaRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatBotUpdateQaResponse, OT>>(
    '/bot/update/qa',
    'POST',
    data,
    options
  );

/**
 * 接口 [删除问答↗](https://yapi.fenxianglife.com/project/379/interface/api/42628) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/delete/qa`
 * @更新时间 `2023-08-10 11:13:25`
 */
export const feimaChatBotDeleteQa = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotDeleteQaRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatBotDeleteQaResponse, OT>>(
    '/bot/delete/qa',
    'POST',
    data,
    options
  );

/**
 * 接口 [查询所有对话记录↗](https://yapi.fenxianglife.com/project/379/interface/api/42976) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/conversation/all`
 * @更新时间 `2023-09-14 10:53:29`
 */
export const feimaChatBotConversationAll = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotConversationAllRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatBotConversationAllResponse, OT>
  >('/bot/conversation/all', 'POST', data, options);

/**
 * 接口 [根据用户分组查询对话记录↗](https://yapi.fenxianglife.com/project/379/interface/api/42982) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/conversation/user`
 * @更新时间 `2023-09-14 10:54:32`
 */
export const feimaChatBotConversationUser = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotConversationUserRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatBotConversationUserResponse, OT>
  >('/bot/conversation/user', 'POST', data, options);

/**
 * 接口 [对话数据统计↗](https://yapi.fenxianglife.com/project/379/interface/api/42988) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/conversation/statistics`
 * @更新时间 `2023-09-15 13:51:41`
 */
export const feimaChatBotConversationStatistics = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotConversationStatisticsRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatBotConversationStatisticsResponse,
      OT
    >
  >('/bot/conversation/statistics', 'POST', data, options);

/**
 * 接口 [修正回答↗](https://yapi.fenxianglife.com/project/379/interface/api/42994) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/conversation/correct`
 * @更新时间 `2023-08-22 13:43:34`
 */
export const feimaChatBotConversationCorrect = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotConversationCorrectRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatBotConversationCorrectResponse, OT>
  >('/bot/conversation/correct', 'POST', data, options);

/**
 * 接口 [修改通知配置↗](https://yapi.fenxianglife.com/project/379/interface/api/43066) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/noticeConfig/set`
 * @更新时间 `2023-08-23 14:49:07`
 */
export const feimaChatBotNoticeConfigSet = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotNoticeConfigSetRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatBotNoticeConfigSetResponse, OT>
  >('/bot/noticeConfig/set', 'POST', data, options);

/**
 * 接口 [获取通知配置↗](https://yapi.fenxianglife.com/project/379/interface/api/43072) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `GET /bot/noticeConfig`
 * @更新时间 `2023-08-23 14:49:24`
 */
export const feimaChatBotNoticeConfig = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotNoticeConfigRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatBotNoticeConfigResponse, OT>>(
    '/bot/noticeConfig',
    'GET',
    data,
    options
  );

/**
 * 接口 [智能体模板列表↗](https://yapi.fenxianglife.com/project/379/interface/api/43096) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/chatBotTemplateList`
 * @更新时间 `2023-11-13 11:26:11`
 */
export const feimaChatBotChatBotTemplateList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotChatBotTemplateListRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatBotChatBotTemplateListResponse, OT>
  >('/bot/chatBotTemplateList', 'POST', data, options);

/**
 * 接口 [智能体模分类↗](https://yapi.fenxianglife.com/project/379/interface/api/43132) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/chatBotTemplateCategoryList`
 * @更新时间 `2023-11-10 10:54:06`
 */
export const feimaChatBotChatBotTemplateCategoryList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotChatBotTemplateCategoryListRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatBotChatBotTemplateCategoryListResponse,
      OT
    >
  >('/bot/chatBotTemplateCategoryList', 'POST', data, options);

/**
 * 接口 [批量删除资源↗](https://yapi.fenxianglife.com/project/379/interface/api/43270) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/resource/batchDelete`
 * @更新时间 `2023-08-31 16:25:46`
 */
export const feimaChatBotResourceBatchDelete = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotResourceBatchDeleteRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatBotResourceBatchDeleteResponse, OT>
  >('/bot/resource/batchDelete', 'POST', data, options);

/**
 * 接口 [删除智能体↗](https://yapi.fenxianglife.com/project/379/interface/api/43528) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/delete`
 * @更新时间 `2023-09-05 16:20:48`
 */
export const feimaChatBotDelete = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotDeleteRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatBotDeleteResponse, OT>>(
    '/bot/delete',
    'POST',
    data,
    options
  );

/**
 * 接口 [智能体发现列表↗](https://yapi.fenxianglife.com/project/379/interface/api/43654) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/discover/list`
 * @更新时间 `2023-09-07 11:44:04`
 */
export const feimaChatBotDiscoverList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotDiscoverListRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatBotDiscoverListResponse, OT>>(
    '/bot/discover/list',
    'POST',
    data,
    options
  );

/**
 * 接口 [发现类目列表↗](https://yapi.fenxianglife.com/project/379/interface/api/43660) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `GET /bot/category/list`
 * @更新时间 `2023-09-07 11:46:40`
 */
export const feimaChatBotCategoryList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data?: ToolTypes.GetRequestType<API.FeimaChatBotCategoryListRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatBotCategoryListResponse, OT>>(
    '/bot/category/list',
    'GET',
    data,
    options
  );

/**
 * 接口 [编辑技能智能体配置↗](https://yapi.fenxianglife.com/project/379/interface/api/44062) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/updateSkillBotConfig`
 * @更新时间 `2023-09-25 14:04:37`
 */
export const feimaChatBotUpdateSkillBotConfig = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotUpdateSkillBotConfigRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatBotUpdateSkillBotConfigResponse, OT>
  >('/bot/updateSkillBotConfig', 'POST', data, options);

/**
 * 接口 [智能体切换列表↗](https://yapi.fenxianglife.com/project/379/interface/api/44668) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `GET /bot/switchList`
 * @更新时间 `2023-10-12 14:07:19`
 */
export const feimaChatBotSwitchList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data?: ToolTypes.GetRequestType<API.FeimaChatBotSwitchListRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatBotSwitchListResponse, OT>>(
    '/bot/switchList',
    'GET',
    data,
    options
  );

/**
 * 接口 [批量创建问答↗](https://yapi.fenxianglife.com/project/379/interface/api/45892) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/create/qa/batch`
 * @更新时间 `2023-11-13 16:48:11`
 */
export const feimaChatBotCreateQaBatch = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotCreateQaBatchRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatBotCreateQaBatchResponse, OT>>(
    '/bot/create/qa/batch',
    'POST',
    data,
    options
  );

/**
 * 接口 [更改智能体自动打标配置↗](https://yapi.fenxianglife.com/project/379/interface/api/46378) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/changeAutomaticMarking`
 * @更新时间 `2023-11-29 13:48:41`
 */
export const feimaChatBotChangeAutomaticMarking = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotChangeAutomaticMarkingRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatBotChangeAutomaticMarkingResponse,
      OT
    >
  >('/bot/changeAutomaticMarking', 'POST', data, options);

/**
 * 接口 [获取智能体自动打标配置↗](https://yapi.fenxianglife.com/project/379/interface/api/46384) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/getAutomaticMarkingConfig`
 * @更新时间 `2023-11-29 17:49:36`
 */
export const feimaChatBotGetAutomaticMarkingConfig = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotGetAutomaticMarkingConfigRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatBotGetAutomaticMarkingConfigResponse,
      OT
    >
  >('/bot/getAutomaticMarkingConfig', 'POST', data, options);

/**
 * 接口 [群报单-群列表↗](https://yapi.fenxianglife.com/project/379/interface/api/46642) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/groupOrderCollect/groupList`
 * @更新时间 `2023-12-21 10:46:54`
 */
export const feimaChatBotGroupOrderCollectGroupList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotGroupOrderCollectGroupListRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatBotGroupOrderCollectGroupListResponse,
      OT
    >
  >('/bot/groupOrderCollect/groupList', 'POST', data, options);

/**
 * 接口 [群报单-客户统计↗](https://yapi.fenxianglife.com/project/379/interface/api/46648) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/groupOrderCollect/statisticsByCustomer`
 * @更新时间 `2024-01-17 15:53:52`
 */
export const feimaChatBotGroupOrderCollectStatisticsByCustomer = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotGroupOrderCollectStatisticsByCustomerRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatBotGroupOrderCollectStatisticsByCustomerResponse,
      OT
    >
  >(
    '/bot/groupOrderCollect/statisticsByCustomer',
    'POST',
    data,
    options
  );

/**
 * 接口 [群报单-商品统计↗](https://yapi.fenxianglife.com/project/379/interface/api/46654) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/groupOrderCollect/statisticsByItem`
 * @更新时间 `2024-01-17 15:55:02`
 */
export const feimaChatBotGroupOrderCollectStatisticsByItem = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotGroupOrderCollectStatisticsByItemRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatBotGroupOrderCollectStatisticsByItemResponse,
      OT
    >
  >(
    '/bot/groupOrderCollect/statisticsByItem',
    'POST',
    data,
    options
  );

/**
 * 接口 [导出群报单记录↗](https://yapi.fenxianglife.com/project/379/interface/api/46792) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/groupOrderCollect/export`
 * @更新时间 `2023-12-21 10:48:38`
 */
export const feimaChatBotGroupOrderCollectExport = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotGroupOrderCollectExportRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatBotGroupOrderCollectExportResponse,
      OT
    >
  >('/bot/groupOrderCollect/export', 'POST', data, options);

/**
 * 接口 [群报单-群分组列表(带微信群)↗](https://yapi.fenxianglife.com/project/379/interface/api/46936) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/groupOrderCollect/groupTagWxGroupList`
 * @更新时间 `2024-01-18 14:15:57`
 */
export const feimaChatBotGroupOrderCollectGroupTagWxGroupList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotGroupOrderCollectGroupTagWxGroupListRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatBotGroupOrderCollectGroupTagWxGroupListResponse,
      OT
    >
  >(
    '/bot/groupOrderCollect/groupTagWxGroupList',
    'POST',
    data,
    options
  );

/**
 * 接口 [群报单-新建群分组↗](https://yapi.fenxianglife.com/project/379/interface/api/46942) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/groupOrderCollect/groupTag/add`
 * @更新时间 `2023-12-21 14:32:49`
 */
export const feimaChatBotGroupOrderCollectGroupTagAdd = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotGroupOrderCollectGroupTagAddRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatBotGroupOrderCollectGroupTagAddResponse,
      OT
    >
  >(
    '/bot/groupOrderCollect/groupTag/add',
    'POST',
    data,
    options
  );

/**
 * 接口 [群报单-删除群分组↗](https://yapi.fenxianglife.com/project/379/interface/api/46948) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/groupOrderCollect/groupTag/del`
 * @更新时间 `2023-12-21 10:36:04`
 */
export const feimaChatBotGroupOrderCollectGroupTagDel = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotGroupOrderCollectGroupTagDelRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatBotGroupOrderCollectGroupTagDelResponse,
      OT
    >
  >(
    '/bot/groupOrderCollect/groupTag/del',
    'POST',
    data,
    options
  );

/**
 * 接口 [群报单-群分组列表↗](https://yapi.fenxianglife.com/project/379/interface/api/46954) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/groupOrderCollect/groupTag/list`
 * @更新时间 `2023-12-21 10:38:29`
 */
export const feimaChatBotGroupOrderCollectGroupTagList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data?: ToolTypes.GetRequestType<API.FeimaChatBotGroupOrderCollectGroupTagListRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatBotGroupOrderCollectGroupTagListResponse,
      OT
    >
  >(
    '/bot/groupOrderCollect/groupTag/list',
    'POST',
    data,
    options
  );

/**
 * 接口 [群报单-群聊设置群分组↗](https://yapi.fenxianglife.com/project/379/interface/api/46960) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/groupOrderCollect/groupTag/setGroupTag`
 * @更新时间 `2023-12-21 11:19:48`
 */
export const feimaChatBotGroupOrderCollectGroupTagSetGroupTag = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotGroupOrderCollectGroupTagSetGroupTagRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatBotGroupOrderCollectGroupTagSetGroupTagResponse,
      OT
    >
  >(
    '/bot/groupOrderCollect/groupTag/setGroupTag',
    'POST',
    data,
    options
  );

/**
 * 接口 [群报单-群聊移除群分组↗](https://yapi.fenxianglife.com/project/379/interface/api/46966) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/groupOrderCollect/groupTag/removeGroupTag`
 * @更新时间 `2023-12-21 10:46:13`
 */
export const feimaChatBotGroupOrderCollectGroupTagRemoveGroupTag = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotGroupOrderCollectGroupTagRemoveGroupTagRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatBotGroupOrderCollectGroupTagRemoveGroupTagResponse,
      OT
    >
  >(
    '/bot/groupOrderCollect/groupTag/removeGroupTag',
    'POST',
    data,
    options
  );

/**
 * 接口 [手动刷新群报单数据↗](https://yapi.fenxianglife.com/project/379/interface/api/47581) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /bot/groupOrderCollect/refreshGroupCollectOrder`
 * @更新时间 `2024-01-18 14:07:19`
 */
export const feimaChatBotGroupOrderCollectRefreshGroupCollectOrder = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotGroupOrderCollectRefreshGroupCollectOrderRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatBotGroupOrderCollectRefreshGroupCollectOrderResponse,
      OT
    >
  >(
    '/bot/groupOrderCollect/refreshGroupCollectOrder',
    'POST',
    data,
    options
  );

/**
 * 接口 [快速开始配置↗](https://yapi.fenxianglife.com/project/379/interface/api/47770) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `GET /bot/chat/quickStartConfig`
 * @更新时间 `2024-02-23 14:31:59`
 */
export const feimaChatBotChatQuickStartConfig = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data?: ToolTypes.GetRequestType<API.FeimaChatBotChatQuickStartConfigRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatBotChatQuickStartConfigResponse, OT>
  >('/bot/chat/quickStartConfig', 'GET', data, options);

/**
 * 接口 [获取智能体同步群状态↗](https://yapi.fenxianglife.com/project/379/interface/api/52560) 的 **请求函数**
 *
 * @分类 [智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9889)
 * @请求头 `POST /wxRobot/sync/group/status`
 * @更新时间 `2024-07-02 14:37:07`
 */
export const feimaChatWxRobotSyncGroupStatus = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWxRobotSyncGroupStatusRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatWxRobotSyncGroupStatusResponse, OT>
  >('/wxRobot/sync/group/status', 'POST', data, options);

/**
 * 接口 [切换当前使用的智能体↗] 的 **请求函数**
 *
 * @分类 [智能体相关↗]
 * @请求头 `POST /bot/switch`
 */
export const feimaChatBotSwitch = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatBotSwitchRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatBotSwitchResponse, OT>>(
    '/bot/switch',
    'POST',
    data,
    options
  );

/* prettier-ignore-end */
